// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"94":"771fe715","145":"6fffea26","156":"0eabb79b","173":"d4ed529d","304":"8fe5e9f6","355":"b4a3a3e7","357":"e33d96d6","453":"11bd3765","836":"d0a0e656","948":"a2e991a4","975":"ed12c437"}[chunkId] + ".chunk.js";
};